import { render, staticRenderFns } from "./admin-register.vue?vue&type=template&id=9fcce678"
import script from "./admin-register.vue?vue&type=script&lang=js"
export * from "./admin-register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports